/* eslint-disable */
<template>
  <section class="invoice-page">

    <!-- Not logged in -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to view your payment receipt.</p>
        <router-link class="login-btn" to="/login" @click="scrollToTop()">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- Logged in -->
    <div v-else class="page-body">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Shop Rent | කඩ කුලී</p>
            <h1 class="page-title">Payment Receipt</h1>
            <p class="page-subtitle">ගෙවීම් රිසිට්පත</p>
          </div>
        </div>
        <div class="timestamp-chip">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          {{ new Date().toLocaleString() }}
        </div>
      </div>

      <form @submit.prevent="submitForm" id="Invoice" novalidate autocomplete="off">

        <!-- ── Sabha Info + Invoice Header ── -->
        <div class="form-card receipt-header-card">
          <div class="receipt-top">
            <div class="receipt-org">
              <div class="org-badge">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
              </div>
              <div>
                <p class="org-system">Local Government Online Payment Management System</p>
                <h2 class="org-name" v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_name_en }}</h2>
                <p class="org-address" v-if="theSabhaData && theSabhaData[0]">{{ theSabhaData[0].sb_address }}</p>
                <p class="org-contact" v-if="theSabhaData && theSabhaData[0]">
                  <span>Tel: {{ theSabhaData[0].sb_contact }}</span>
                  <span>Fax: {{ theSabhaData[0].fax }}</span>
                </p>
              </div>
            </div>
            <div class="receipt-meta">
              <div class="invoice-number">
                <p class="inv-label">Invoice No.</p>
                <p class="inv-value">{{ InvouceNum }}</p>
              </div>
              <div class="receipt-type-badge">Payment Receipt</div>
            </div>
          </div>
        </div>

        <!-- ── Customer Details ── -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Customer Details</h2>
              <p class="card-desc">ගනුදෙනුකරුවාගේ තොරතුරු</p>
            </div>
          </div>
          <div class="detail-grid">
            <div class="detail-item">
              <span class="detail-label">NIC</span>
              <span class="detail-value nic-value">{{ user.cus_nic }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Full Name</span>
              <span class="detail-value">{{ user.cus_name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Remarks</span>
              <span class="detail-value">{{ remark }}</span>
            </div>
          </div>
        </div>

        <!-- ── Payment Summary Only ── -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
              </svg>
            </div>
            <div>
              <h2 class="card-title">Payment Summary</h2>
              <p class="card-desc">ගෙවීම් සාරාංශය</p>
            </div>
          </div>

          <div class="summary-breakdown">
            <div class="summary-line" v-if="parseFloat(summaryTotals.prevArrears) > 0">
              <span class="sl-label"><span class="amount-dot dot-arrears"></span>Previous Year Arrears</span>
              <span class="sl-value">Rs. {{ fmt(summaryTotals.prevArrears) }}</span>
            </div>
            <div class="summary-line" v-if="parseFloat(summaryTotals.prevFine) > 0">
              <span class="sl-label"><span class="amount-dot dot-fine"></span>Previous Year Fine</span>
              <span class="sl-value fine-val">Rs. {{ fmt(summaryTotals.prevFine) }}</span>
            </div>
            <div class="summary-line" v-if="parseFloat(summaryTotals.currArrears) > 0">
              <span class="sl-label"><span class="amount-dot dot-arrears"></span>Current Year Arrears</span>
              <span class="sl-value">Rs. {{ fmt(summaryTotals.currArrears) }}</span>
            </div>
            <div class="summary-line" v-if="parseFloat(summaryTotals.currFine) > 0">
              <span class="sl-label"><span class="amount-dot dot-fine"></span>Current Year Fine</span>
              <span class="sl-value fine-val">Rs. {{ fmt(summaryTotals.currFine) }}</span>
            </div>
            <div class="summary-line" v-if="parseFloat(summaryTotals.rent) > 0">
              <span class="sl-label"><span class="amount-dot dot-rent"></span>Monthly Rent</span>
              <span class="sl-value">Rs. {{ fmt(summaryTotals.rent) }}</span>
            </div>
            <div class="summary-line summary-line--sub">
              <span class="sl-label">Sub Total</span>
              <span class="sl-value">Rs. {{ fmt(total) }}</span>
            </div>
            <div class="summary-line">
              <span class="sl-label">Banking Service Charge</span>
              <span class="sl-value">Rs. {{ fmt(bankfee) }}</span>
            </div>
            <div class="summary-line summary-line--grand">
              <span class="sl-label">Grand Total</span>
              <span class="sl-value grand-val">Rs. {{ fmt(grandPayTotal) }}</span>
            </div>
          </div>
        </div>

        <!-- ── Certification + Pay ── -->
        <div class="form-card certify-card">
          <label class="certify-label" :class="{ checked: checkVal }">
            <div class="custom-checkbox" :class="{ checked: checkVal }">
              <svg v-if="checkVal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
              </svg>
            </div>
            <input type="checkbox" id="checkid" v-model="checkVal" @click="btnenable" class="hidden-check"/>
            <span class="certify-text">
              I certify that the above information is true and correct.<br>
              <em>ඉහත තොරතුරු සත්‍ය හා නිවැරදි බවට සහතික කරමි.</em>
            </span>
          </label>

          <div class="pay-action" v-if="theSabhaData && theSabhaData[0] && theSabhaData[0].saba_ipg === 'BOC'">
            <div class="grand-total-display">
              <span class="gtd-label">Grand Total Payable</span>
              <span class="gtd-amount">Rs. {{ fmt(grandPayTotal) }}</span>
            </div>
            <button class="pay-btn" id="payboc" type="submit" :disabled="disableButton">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
              </svg>
              Pay Now
            </button>
          </div>
        </div>

      </form>

      <!-- IPG Form Response -->
      <div v-html="form" id="formResponse" class="form-group" style="display:none;"></div>

    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";

export default {
  name: "ShopRentInvoice2",

  data() {
    return {
      // session / invoice meta
      sessionData: '', InvouceNum: '', sabha_code: '', remark: '',
      month: '', year: '', Nic: '',
      // sabha + user
      theSabhaData: [], matchUser: undefined, cusName: '',
      // shop data
      shopDeID: [], AllShopDtails: [],
      // computed per-shop rows (still needed for calculations & DB writes)
      computedShops: [],
      // grand totals
      total: 0, grandPayTotal: 0, bankfee: 0,
      // summary breakdown accumulators
      summaryTotals: {
        prevArrears: 0, prevFine: 0, currArrears: 0, currFine: 0, rent: 0,
      },
      // misc
      currentDate: new Date(), serverDate: '',
      checkVal: '', disableButton: true, ipg: '',
      formData: {
        boc_sid: '', boc_paytype: '', boc_amount: '', boc_grandamount: '',
        boc_cus_nic: '', boc_invoice: '', boc_remarks: '',
        country: '', street: '', street2: '', city: '', state: '', zip: '',
      },
    };
  },

  created() { this.getSessionData(); },

  computed: { ...mapState(["user"]) },

  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    fmt(val) {
      return parseFloat(val || 0).toLocaleString('en-LK', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    },

    formattedDate() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    },

    async MatchUser(nic) {
      const data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    getMonthNameByNum(n) {
      const m = ['January','February','March','April','May','June',
                 'July','August','September','October','November','December'];
      return (n >= 1 && n <= 12) ? m[n - 1] : 'Invalid';
    },

    getMonthName(n) {
      const d = new Date(this.serverDate);
      d.setMonth(n);
      return d.toLocaleString('en-US', { month: 'long' });
    },

    isGreaterThan10th(finedate) {
      return this.currentDate.getDate() > finedate;
    },

    getPaymentOfMonth(paymonth1, rent, pyear) {
      if (paymonth1 === (this.currentDate.getMonth() + 1) &&
          pyear     ===  this.currentDate.getFullYear()) return 0;
      return parseFloat(rent);
    },

    DiffOfMonthstwoYear(pm, cr, current_arrears, payYear) {
      if (pm < 1 || pm > 12) throw new Error('Month must be between 1 and 12');
      const d  = new Date(this.serverDate);
      const cm = d.getMonth() + 1;
      const cy = d.getFullYear();

      cr              = parseFloat(cr)              || 0;
      current_arrears = parseFloat(current_arrears) || 0;

      const totalMonths   = (cy - payYear) * 12 + (cm - pm);
      const arrearsMonths = totalMonths - 1;

      if (arrearsMonths <= 0) {
        return { currentYearDiff: 0, previousYearDiff: 0,
                 currentYearArrears: "0.00", previousYearArrears: "0.00" };
      }

      const currentYearDiff  = Math.min(arrearsMonths, cm - 1);
      const previousYearDiff = arrearsMonths - currentYearDiff;

      let prevYearArrears = previousYearDiff * cr;
      let curArrears      = currentYearDiff  * cr;

      if (previousYearDiff > 0) prevYearArrears += current_arrears;
      else                       curArrears      += current_arrears;

      return {
        currentYearDiff,
        previousYearDiff,
        currentYearArrears:  curArrears.toFixed(2),
        previousYearArrears: prevYearArrears.toFixed(2),
      };
    },

    calcShopAmounts(r) {
      const monthlyRent        = parseFloat(r.monthly_shop_rent) || 0;
      const fineRatePercentage = parseFloat(r.fine_rate || 0) / 100;
      const finedate           = r.fine_date          || 0;
      const fineMonthCount     = parseInt(r.fine_month_count) || 0;
      const excessArrears      = parseFloat(r.arrears) || 0;

      const split = this.DiffOfMonthstwoYear(
        r.pay_month, r.monthly_shop_rent, r.arrears, r.pay_year
      );

      let cyArrears = parseFloat(split.currentYearArrears);
      let pyArrears = parseFloat(split.previousYearArrears);

      if (fineMonthCount > 0) {
        cyArrears = Math.max(0, cyArrears - (monthlyRent * fineMonthCount));
      }

      const monthlyRentDue = this.getPaymentOfMonth(r.pay_month, r.monthly_shop_rent, r.pay_year);

      let fine = 0, prefineamount = 0;
      if (monthlyRent > 0) {
        let numarr    = cyArrears > 0 ? cyArrears / monthlyRent : 0;
        let numarrpre = pyArrears > 0 ? pyArrears / monthlyRent : 0;

        if (this.isGreaterThan10th(finedate) &&
            parseFloat(r.fine_rate || 0) > 0 &&
            monthlyRentDue !== 0) {
          numarr += 1;
        }

        fine = cyArrears > 0
          ? (numarr > 0 ? monthlyRent * fineRatePercentage * numarr : 0)
          : (monthlyRent * fineRatePercentage * numarr);

        prefineamount = pyArrears > 0
          ? (numarrpre > 0 ? monthlyRent * fineRatePercentage * numarrpre : 0)
          : 0;
      }

      const cyArrearsDisplay = cyArrears > 0 ? cyArrears
                             : (excessArrears < 0 ? excessArrears : 0);

      const prevYearTotal = pyArrears + prefineamount;
      const currYearTotal = parseFloat(cyArrearsDisplay) + fine + monthlyRentDue;
      const totalAmount   = prevYearTotal + currYearTotal;

      return {
        previousYearArrears: pyArrears.toFixed(2),
        prefineamount:        prefineamount.toFixed(2),
        currentYearArrears:   parseFloat(cyArrearsDisplay).toFixed(2),
        fine:                 fine.toFixed(2),
        monthlyRentDue:       parseFloat(monthlyRentDue).toFixed(2),
        prevYearTotal:        prevYearTotal.toFixed(2),
        currYearTotal:        currYearTotal.toFixed(2),
        totalAmount:          totalAmount.toFixed(2),
      };
    },

    getFormattedMonthAndYear(payMonth, payYear) {
      const cm = this.currentDate.getMonth() + 1;
      const cy = this.currentDate.getFullYear();
      if (payYear === cy && payMonth > cm) return [payMonth + 1, payYear];
      if (payYear === cy && payMonth < cm) return [cm, payYear];
      if (payYear > cy)                    return [payMonth + 1, cy + 1];
      return [cm, cy];
    },

    // Isolated fire-and-forget — ER_DUP_ENTRY on reload is silently ignored
    async postShopRentTempRows(shop, c, paidMonth, paidYear) {
      const base = {
        rent_cus_nic:      this.user.cus_nic,
        rent_invoice_num:  this.InvouceNum,
        rent_sabha_code:   this.sabha_code,
        rent_shop_place:   shop.place,
        rent_shop_no:      shop.shop_number,
        rent_description:  this.remark,
        rent_month:        paidMonth,
        rent_year:         paidYear,
        rent_total_amount: c.totalAmount,
      };

      const posts = [];

      if (parseFloat(c.monthlyRentDue) > 0) {
        posts.push({
          ...base,
          rent_price:        parseFloat(c.monthlyRentDue).toFixed(2),
          rent_fine:         0,
          rent_pay_amount:   parseFloat(c.monthlyRentDue).toFixed(2),
          available_arrears: 0,
          rent_with_arrears: parseFloat(c.monthlyRentDue).toFixed(2),
          income_head_id:    shop.rent_vote,
          pay_fine:          0,
        });
      }

      if (parseFloat(c.currentYearArrears) > 0) {
        posts.push({
          ...base,
          rent_price:        0,
          rent_fine:         0,
          rent_pay_amount:   c.currentYearArrears,
          available_arrears: c.currentYearArrears,
          rent_with_arrears: c.currentYearArrears,
          income_head_id:    shop.arrears_vote,
          pay_fine:          0,
        });
      }

      if (parseFloat(c.previousYearArrears) > 0) {
        posts.push({
          ...base,
          rent_price:        0,
          rent_fine:         0,
          rent_pay_amount:   c.previousYearArrears,
          available_arrears: c.previousYearArrears,
          rent_with_arrears: c.previousYearArrears,
          income_head_id:    shop.arrears_vote,
          pay_fine:          0,
        });
      }

      const totalFine = parseFloat(c.prefineamount) + parseFloat(c.fine);
      if (totalFine > 0) {
        posts.push({
          ...base,
          rent_price:        0,
          rent_fine:         totalFine.toFixed(2),
          rent_pay_amount:   totalFine.toFixed(2),
          available_arrears: 0,
          rent_with_arrears: 0,
          income_head_id:    shop.fine_vote,
          pay_fine:          totalFine.toFixed(2),
        });
      }

      for (const payload of posts) {
        try {
          await axios.post("/shoprentstemp/", payload);
        } catch (err) {
          if (err.response?.data?.code === 'ER_DUP_ENTRY') {
            console.warn('shoprentstemp: duplicate row skipped (already inserted)');
            continue;
          }
          console.error('shoprentstemp insert failed:', err);
        }
      }
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('rentDetails'));
      if (data) {
        this.sabha_code = data.sabha_code;
        this.remark     = data.remark;
        this.month      = data.month;
        this.year       = data.year;
        this.InvouceNum = data.invoiceNum;
      }
      this.sessionData = data;

      const nicdata = JSON.parse(sessionStorage.getItem('Userdata'));
      if (nicdata) this.Nic = nicdata.Unic;
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);

      try {
        const res        = await axios.get('/getserverdate');
        this.serverDate  = res.data.serverDate;
        this.currentDate = new Date(this.serverDate);
      } catch (e) { console.error("Error fetching server date:", e); }

      if (!this.sessionData) { this.$router.push('/shoprentexist'); return; }

      this.theSabhaData = (await axios.get('/PraSabhadata/' + this.sabha_code)).data;
      this.ipg = this.theSabhaData[0].saba_ipg;

      this.shopDeID = JSON.parse(sessionStorage.getItem('shopDataid'));
      for (let i = 0; i < this.shopDeID.length; i++) {
        const temp = (await axios.get('/shopdataid/' + this.shopDeID[i])).data;
        if (temp && temp.length) this.AllShopDtails.push(temp[0]);
      }

      // Calculate totals synchronously first — DB writes are fire-and-forget
      let grandSubTotal = 0;
      const st = { prevArrears: 0, prevFine: 0, currArrears: 0, currFine: 0, rent: 0 };

      for (const shop of this.AllShopDtails) {
        const c = this.calcShopAmounts(shop);
        this.computedShops.push({ shop, c });

        st.prevArrears += parseFloat(c.previousYearArrears);
        st.prevFine    += parseFloat(c.prefineamount);
        st.currArrears += parseFloat(c.currentYearArrears);
        st.currFine    += parseFloat(c.fine);
        st.rent        += parseFloat(c.monthlyRentDue);
        grandSubTotal  += parseFloat(c.totalAmount);

        const [paidMonth, paidYear] = this.getFormattedMonthAndYear(shop.pay_month, shop.pay_year);
        this.month = paidMonth;
        this.year  = paidYear;

        // Fire-and-forget — never blocks totals
        this.postShopRentTempRows(shop, c, paidMonth, paidYear);
      }

      // Set totals immediately — independent of async DB writes
      this.summaryTotals = st;
      this.total = grandSubTotal.toFixed(2);

      if (this.ipg === 'BOC') {
        this.bankfee = (parseFloat(this.total) * ((100 / (100 - 1)) - 1)).toFixed(2);
      } else if (this.ipg === 'people') {
        this.bankfee = (parseFloat(this.total) * 0.01).toFixed(2);
      } else {
        this.bankfee = '0.00';
      }
      this.grandPayTotal = (
        (parseFloat(this.bankfee) || 0) + (parseFloat(this.total) || 0)
      ).toFixed(2);

      // onlinepaymenttemp summary row
      try {
        await axios.post("/onlinepaymenttemp/", {
          online_cus_nic:     this.user.cus_nic,
          online_sabha_code:  this.sabha_code,
          online_invoice_num: this.InvouceNum,
          online_pay_amount:  this.total,
          online_pay_month:   this.month,
          online_pay_year:    this.year,
          online_pay_des:     this.remark,
          pay_type:           'shoprent',
          vote:               this.AllShopDtails.length ? this.AllShopDtails[0].rent_vote : '',
          online_pay_date:    this.formattedDate(),
        });
      } catch (err) {
        if (err.response?.data?.code === 'ER_DUP_ENTRY') {
          console.warn('onlinepaymenttemp: duplicate row skipped');
        } else {
          console.error('onlinepaymenttemp insert failed:', err);
        }
      }

      // IPG form
      const postData = {
        mid:                     this.sabha_code,
        paytype:                 'shoprent',
        amount:                  this.grandPayTotal,
        referenceNumber:         this.InvouceNum,
        email:                   this.user.cus_email,
        bill_to_forename:        this.user.cus_nic,
        bill_to_surname:         this.user.cus_name,
        bill_to_address_line1:   this.user.cus_address,
        bill_to_address_line2:   this.user.cus_address,
        bill_to_address_city:    'shoprent',
        bill_to_address_country: 'LK',
      };
      axios.post('/process-payment', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(res => { document.getElementById('formResponse').innerHTML = res.data; })
        .catch(err => { console.error(err); });
    },

    btnenable() {
      if (this.checkVal === true) {
        document.getElementById('formResponse').style.display = 'none';
        this.disableButton = true;
      } else {
        document.getElementById('formResponse').style.display = 'block';
        this.disableButton = !this.disableButton;
      }
    },

    submitForm() {
      Object.assign(this.formData, {
        boc_sid:         this.sabha_code,
        boc_paytype:     'shoprent',
        boc_amount:      this.total,
        boc_grandamount: this.grandPayTotal,
        boc_cus_nic:     this.user.cus_nic,
        boc_invoice:     this.InvouceNum,
        boc_remarks:     this.remark,
        country: 'LKA', street: '25466', street2: 'shoprent',
        city: '25466', state: '25466', zip: '25466',
      });
      const backendUrl = window.sessionStorage.getItem("backendUrl") || "https://elgservices.com.lk/api";
      // const backendUrl = window.sessionStorage.getItem("backendUrl") || "https://elgservices.com.lk/api";
      axios.post(backendUrl + '/bocpay/', this.formData)
        .then(res => {
           window.location.href = "https://test-bankofceylon.mtf.gateway.mastercard.com/checkout/pay/"+res.data.sessionid+"?checkoutVersion=1.0.0"   // test url
          // window.location.href =
            // `https://bankofceylon.gateway.mastercard.com/checkout/pay/${res.data.sessionid}?checkoutVersion=1.0.0`;
        })
        .catch(err => console.error(err));
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.invoice-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 860px; margin: 0 auto; }

/* ── Login Prompt ── */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 .8rem; }
.login-card p  { font-size: 1.4rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1rem 2.6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: .8rem; font-size: 1.45rem; font-weight: 600;
  text-decoration: none; transition: all .2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: .12em; text-transform: uppercase; color: #9a6652; margin: 0 0 .3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 .3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }
.timestamp-chip {
  display: inline-flex; align-items: center; gap: .6rem;
  padding: .65rem 1.2rem;
  background: #fff; border: 1px solid #e5ddd5; border-radius: .7rem;
  font-size: 1.25rem; color: #4a3028;
  box-shadow: 0 1px 4px rgba(100,50,30,.06); white-space: nowrap;
}
.timestamp-chip svg { width: 1.5rem; height: 1.5rem; stroke: #c2440a; flex-shrink: 0; }

/* ── Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2rem 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,.06);
  margin-bottom: 1.6rem;
}
.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 1.6rem; padding-bottom: 1.4rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.8rem; height: 3.8rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.8rem; height: 1.8rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.7rem; color: #1c0f0a; margin: 0 0 .15rem; }
.card-desc  { font-size: 1.25rem; color: #9a8070; margin: 0; }

/* ── Receipt Header ── */
.receipt-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 2rem; flex-wrap: wrap; }
.receipt-org { display: flex; align-items: flex-start; gap: 1.4rem; }
.org-badge {
  width: 4rem; height: 4rem; border-radius: .8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.org-badge svg { width: 2rem; height: 2rem; stroke: #fff; }
.org-system  { font-size: 1.1rem; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: #9a6652; margin: 0 0 .2rem; }
.org-name    { font-family: 'DM Serif Display', serif; font-size: 1.7rem; color: #1c0f0a; margin: 0 0 .2rem; }
.org-address { font-size: 1.25rem; color: #4a3028; margin: 0 0 .2rem; }
.org-contact { display: flex; gap: 1.5rem; font-size: 1.2rem; color: #9a8070; margin: 0; }
.receipt-meta { text-align: right; display: flex; flex-direction: column; align-items: flex-end; gap: .8rem; }
.inv-label  { font-size: 1.1rem; font-weight: 600; text-transform: uppercase; letter-spacing: .08em; color: #9a6652; margin: 0; }
.inv-value  { font-family: 'DM Serif Display', serif; font-size: 1.7rem; color: #7c2d12; margin: 0; }
.receipt-type-badge {
  display: inline-block; padding: .4rem 1.2rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 99px;
  font-size: 1.2rem; font-weight: 600; letter-spacing: .04em;
}

/* ── Detail Grid ── */
.detail-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.2rem; }
.detail-item { background: #faf8f6; border: 1px solid #f0e6de; border-radius: .7rem; padding: 1rem 1.2rem; }
.detail-label { font-size: 1.1rem; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #9a6652; display: block; margin-bottom: .3rem; }
.detail-value { font-size: 1.35rem; color: #1c0f0a; font-weight: 500; }
.nic-value { font-family: 'DM Serif Display', serif; font-size: 1.4rem; color: #7c2d12; }

/* ── Amount dots ── */
.amount-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; }
.dot-arrears { background: #c2440a; }
.dot-fine    { background: #b91c1c; }
.dot-rent    { background: #166534; }

/* ── Summary breakdown ── */
.summary-breakdown { display: flex; flex-direction: column; gap: .5rem; }
.summary-line {
  display: flex; align-items: center; justify-content: space-between;
  gap: 2rem; padding: .65rem 1rem;
  border-radius: .5rem;
}
.summary-line:not(.summary-line--sub):not(.summary-line--grand):hover {
  background: #faf8f6;
}
.summary-line--sub {
  border-top: 1px dashed #e5ddd5; margin-top: .5rem; padding-top: 1rem;
  font-weight: 700;
}
.summary-line--grand {
  background: #fdf4f0; border: 1px solid #f0c8b8;
  border-radius: .8rem; padding: 1rem 1.2rem; margin-top: .5rem;
}
.sl-label {
  font-size: 1.3rem; color: #4a3028; font-weight: 500;
  display: flex; align-items: center; gap: .6rem;
}
.sl-value { font-size: 1.35rem; font-weight: 700; color: #1c0f0a; font-variant-numeric: tabular-nums; white-space: nowrap; }
.fine-val  { color: #b91c1c; }
.grand-val { font-family: 'DM Serif Display', serif; font-size: 1.9rem; color: #7c2d12; }

/* ── Certify Card ── */
.certify-card { display: flex; align-items: center; justify-content: space-between; gap: 2rem; flex-wrap: wrap; }
.certify-label { display: flex; align-items: flex-start; gap: 1rem; cursor: pointer; flex: 1; }
.hidden-check { display: none; }
.custom-checkbox {
  width: 2.2rem; height: 2.2rem; flex-shrink: 0; margin-top: .1rem;
  border: 2px solid #e5ddd5; border-radius: .4rem; background: #faf8f6;
  display: flex; align-items: center; justify-content: center; transition: all .2s;
}
.custom-checkbox.checked { background: linear-gradient(135deg, #7c2d12, #c2440a); border-color: transparent; }
.custom-checkbox svg { width: 1.4rem; height: 1.4rem; stroke: #fff; }
.certify-text { font-size: 1.3rem; color: #4a3028; line-height: 1.6; }
.certify-text em { font-size: 1.2rem; color: #9a8070; font-style: normal; }
.certify-label.checked .certify-text { color: #1c0f0a; }

.pay-action { display: flex; align-items: center; gap: 2rem; flex-wrap: wrap; justify-content: flex-end; }
.grand-total-display { text-align: right; }
.gtd-label  { font-size: 1.1rem; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #9a6652; display: block; margin-bottom: .2rem; }
.gtd-amount { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #7c2d12; font-weight: 700; }
.pay-btn {
  display: inline-flex; align-items: center; gap: .7rem;
  padding: 1rem 2.6rem;
  background: linear-gradient(135deg, #166534, #16a34a);
  color: #fff; border: none; border-radius: .8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(22,101,52,.28), 0 0 0 3px rgba(22,163,74,.15);
  transition: all .2s;
}
.pay-btn svg { width: 1.8rem; height: 1.8rem; }
.pay-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #14532d, #15803d);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(22,101,52,.38), 0 0 0 4px rgba(22,163,74,.2);
}
.pay-btn:disabled { opacity: .45; cursor: not-allowed; transform: none; box-shadow: none; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .invoice-page  { padding: 1.5rem 1rem 3rem; }
  .page-title    { font-size: 2rem; }
  .page-header   { flex-direction: column; }
  .form-card     { padding: 1.5rem; }
  .receipt-top   { flex-direction: column; }
  .receipt-meta  { text-align: left; align-items: flex-start; }
  .detail-grid   { grid-template-columns: 1fr 1fr; }
  .certify-card  { flex-direction: column; align-items: flex-start; }
  .pay-action    { width: 100%; justify-content: space-between; }
}
@media (max-width: 520px) {
  .detail-grid   { grid-template-columns: 1fr; }
  .pay-btn       { width: 100%; justify-content: center; }
  .grand-val     { font-size: 1.5rem; }
}
</style>